import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import JobEditor from "@/pages/admin/JobEditor";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/jobs/$id")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-job-editor", path: "/admin/jobs/$id", title: "Cloud Admin Job Editor", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><JobEditor /></AdminLayout>,
});
